import { LOGIN } from '../../../utils/endpoints';

export const cooperationLogin = async (
  phone,
  verification_code,
  phoneCode,
) => {
  try {
    const res = await fetch(LOGIN, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({
        verification_code,
        phone,
        country_code: phoneCode,
      }),
    });

    const data = await res.json();

    return data;
  } catch (error) {
    return error;
  }
};
